import React, {useContext} from "react"

export const HeaderContext = React.createContext({
    title: undefined,
    setTitle: undefined
})


export const useHeader = () => useContext(HeaderContext)